import React, { useState, useEffect, useContext } from "react";
import languageContext from "../context/language/languageContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AdminStudentDashboard = () => {
  const [students, setStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const { setSessionTimeout, setAlert, setMessage } = useContext(languageContext);
  const navigate = useNavigate();

  const getStudentDetails = async () => {
    setLoading(true);
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/admin_school_details_interaction",
        {},
        { headers: headersList }
      );
      if (response.status === 200) {
        setStudents(response.data?.data || []);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const searchStudents = async (value) => {
    setLoading(true);
    const headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/admin_school_details_interaction",
        { search: value },
        { headers: headersList }
      );
      if (response.status === 200) {
        setStudents(response.data?.data || []);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleError = (error) => {
    if (error.response?.data?.detail === "Token has expired") {
      setSessionTimeout(true);
    } else {
      console.error("Error Details:", error.message);
      setAlert(true);
      setMessage("Please try again later, something went wrong");
    }
  };

  useEffect(() => {
    const init = async () => {
      const loginBool = localStorage.getItem("login");
      const currentPagePath = window.location.pathname;
      if (loginBool === "true") {
        navigate("/admin-dashboard", { state: { url: currentPagePath } });
        await getStudentDetails();
      } else {
        navigate("/", { state: { url: currentPagePath } });
      }
    };

    init();
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim()) searchStudents(searchTerm.trim());
      else getStudentDetails();
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleView = (path, studentId) => {
    navigate(path, { state: { student_id: studentId } });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 p-4 pt-24">
      <h1 className="text-3xl font-bold text-center text-blue-800 mb-8">
        Admin Dashboard – University Students
      </h1>

      <div className="flex justify-center mb-8">
        <input
          type="text"
          placeholder="Search by name, phone, UID, or college"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full max-w-md px-4 py-2 border border-blue-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-16">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {students.map((student) => (
            <div
              key={student.id}
              className="bg-white border border-blue-200 shadow-md rounded-xl p-5 transition hover:shadow-lg flex flex-col justify-between"
            >
              <div className="mb-4 min-h-[200px]">
                <h2 className="text-xl font-semibold text-blue-700 mb-1">{student.name}</h2>
                <p className="text-sm text-gray-600 mb-1"><strong>UID:</strong> {student.uid}</p>
                <p className="text-sm text-gray-600"><strong>College:</strong> {student.college_name}</p>
                <p className="text-sm text-gray-600"><strong>Hostel:</strong> {student.hostel}</p>
                <p className="text-sm text-gray-600"><strong>Warden:</strong> {student.warden} ({student.warden_phone_number})</p>
                <p className="text-sm text-gray-600"><strong>Parent:</strong> {student.parent_name} ({student.parent_phone_number})</p>
                <p className="text-sm text-gray-600"><strong>Medical Officer:</strong> {student.medical_officer} ({student.medical_officer_phone_number})</p>
              </div>

              <div className="space-y-2">
                <button
                  onClick={() => handleView("/view_leave_alerts", student.id)}
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white py-2 rounded-lg text-sm"
                >
                  🚪 Leave Requests
                </button>
                <button
                  onClick={() => handleView("/chat_history", student.student_id)}
                  className="w-full bg-sky-600 hover:bg-sky-700 text-white py-2 rounded-lg text-sm"
                >
                  💬 Chat History
                </button>
                <button
                  onClick={() => handleView("/prescription_history", student.id)}
                  className="w-full bg-purple-600 hover:bg-purple-700 text-white py-2 rounded-lg text-sm"
                >
                  📄 Prescription History
                </button>
                <button
                  onClick={() => handleView("/view_lab_test", student.id)}
                  className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg text-sm"
                >
                  🧪 Lab Tests
                </button>
                <button
                  onClick={() => handleView("/view_reminder", student.id)}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm"
                >
                  ⏰ Reminders
                </button>
              </div>
            </div>

          ))}
        </div>
      )}
    </div>
  );
};

export default AdminStudentDashboard;
